import React from "react";
import { Reveal } from "@/components/motion/Reveal";

/** Editorial page hero — kicker label, serif title, intro paragraph, optional image. */
export const PageHero = ({ kicker, title, text, image, testId = "page-hero" }) => {
  return (
    <section data-testid={testId} className="relative overflow-hidden bg-warm-ivory">
      <div className="mx-auto max-w-7xl px-5 pb-14 pt-16 lg:px-10 lg:pb-20 lg:pt-24">
        <div className={`grid items-end gap-10 ${image ? "lg:grid-cols-[1.3fr_1fr]" : ""}`}>
          <div className="max-w-3xl">
            {kicker && (
              <Reveal>
                <p className="mb-5 text-sm font-medium uppercase tracking-editorial text-champagne-gold">
                  {kicker}
                </p>
              </Reveal>
            )}
            <Reveal delay={0.05}>
              <h1 className="text-balance font-serif text-4xl leading-[1.05] tracking-tight text-deep-ink sm:text-5xl lg:text-6xl">
                {title}
              </h1>
            </Reveal>
            {text && (
              <Reveal delay={0.1}>
                <p className="mt-6 max-w-2xl text-lg leading-relaxed text-deep-ink/70">{text}</p>
              </Reveal>
            )}
          </div>
          {image && (
            <Reveal delay={0.15}>
              <div className="relative aspect-[4/5] overflow-hidden rounded-3xl">
                <img src={image} alt="" className="h-full w-full object-cover" />
              </div>
            </Reveal>
          )}
        </div>
      </div>
    </section>
  );
};
